module.exports = __webpack_public_path__ + "img/logo.2025d951.png";